import styled from 'styled-components'
import {
  Button,
  Card,
  Details,
  ImageWrapper,
} from '@components/SuggestedHorizontalProduct/SuggestedHorizontalProduct.styles'
import { PriceRow } from '@velasca/ui/price-row'
import { SansText } from '@velasca/ui/sans-text'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const Title = styled.h3`
  font-family: ${({ theme }) => theme.fonts.brand};
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 125%;
  letter-spacing: 0;
  text-transform: uppercase;
`

export const ProductsContainer = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  list-style: none;
  padding: 0;

  ${Card} {
    padding: 0;
    padding-top: 1rem;

    ${ImageWrapper} {
      height: 17.5rem;
    }

    ${Details} {
      gap: 1.1rem;
    }
  }
  ${Button} {
    padding: 1.7rem 1.5rem;

    ${SansText} {
      font-weight: 500;
      font-size: 1.4rem;
      line-height: 125%;
      letter-spacing: 0;
    }
  }
  ${PriceRow} {
    margin-top: 1rem;
    ${SansText} {
      font-size: 1.8rem;

      &[color='gray'] {
        font-size: 1.6rem !important;
      }
    }
  }
`
